<fieldset
  [class]="'view-chooser ' + theme"
  [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : null"
  [class.force-white]="forceWhite"
  [class.no-wrap]="nowrap"
  [class.radio-button]="workAsRadioButton"
  [attr.role]="isUsedAsTab ? 'tablist' : 'radiogroup'"
>
  @for (option of options; track option; let i = $index) {
    <label
      [for]="option.name"
      class="option"
      [class.selected]="option.selected"
      (keyup.enter)="selectOption(option, $event)"
      (keydown.space)="selectOption(option, $event)"
      (keyup.ArrowUp)="selectPrevOption(i)"
      (keyup.ArrowLeft)="selectPrevOption(i)"
      (keyup.ArrowDown)="selectNextOption(i)"
      (keyup.ArrowRight)="selectNextOption(i)"
      (click)="clickSelectOption(option, $event)"
      [tabindex]="isUsedAsTab && option.selected ? 0 : -1"
      [role]="isUsedAsTab ? 'tab' : null"
      [id]="'tab-' + option.id"
      [attr.aria-selected]="isUsedAsTab && option.selected ? 'true' : 'false'"
      [attr.aria-controls]="isUsedAsTab ? 'tabpanel-' + option.id : null"
    >
      <input
        type="radio"
        [style]="isUsedAsTab ? 'display: none;' : ''"
        class="sr-only"
        [name]="uniqueID"
        [tabindex]="!isUsedAsTab && option.selected ? 0 : -1"
        [id]="option.name"
        [attr.aria-checked]="option.selected"
        [checked]="option.selected"
      />
      {{ option.translationKey ? (option.translationKey | translate) : option.name }}
    </label>
  }
</fieldset>
